import { Injectable } from '@angular/core';
import { ActivatedRoute,ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { PermissionsService } from '../services/permissions.service';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { FULL_NAV_LEVEL } from '../constants/access-levels';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class AuthGuardService implements CanActivate {
	menuItems: any = [];;
	pagesubscription: any;
	user: any = [];
	version: any = false;
	timestamp = new Date().getTime(); // Get current timestamp
	url = '/assets/version.json';
	constructor(
			private http: HttpClient,
			protected auth: AuthService,
			public router: Router ,
			public currentroute: ActivatedRoute ,
			protected permissionsService: PermissionsService,
			protected globalSearchService: GlobalSearchService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
	//canActivate(route: ActivatedRouteSnapshot, router: Router): boolean {
		const logged = this.auth.isAuthenticated;
		if (!this.auth.isAuthenticated()) {
			this.router.navigate(['auth/login']);
			return false;
		}
		//state.url
		if(state.url && state.url != 'auth/permission') {
			this.globalSearchService.user.subscribe( user => {
				this.user = user;
				const fullaccess = parseInt(user?.user?.fullaccess ?? '0', 10);
				const allowByLevel = fullaccess >= FULL_NAV_LEVEL;
				const isStorefront = state.url === '/storefront' || state.url === 'storefront' || state.url.startsWith('/storefront/') || state.url.startsWith('storefront/');
				const storefrontAllowed = user.user.access_permissions && isStorefront && user.user.access_permissions.includes('/system/storefront-settings');
				this.pagesubscription = allowByLevel || (user.user.access_permissions && user.user.access_permissions.includes(state.url)) || storefrontAllowed;

				if(!this.pagesubscription) {
					//this.router.navigate(['auth/permission']);
				}
			});
		}
		/*
		this.globalSearchService.user.subscribe( user => {
			return this.permissionsService.checkPermission(user, this.router.url, []);
		})
		*/
		let version = JSON.parse(localStorage.getItem('v8version'));
		this.http.get(this.url+'?t='+this.timestamp).subscribe( (res:any) => {

			if(res.version) {
				if(version === null ) {
					localStorage.setItem('v8version', JSON.stringify(res))
					window.location.reload();
				} else {
					version = JSON.parse(localStorage.getItem('v8version'));
					if(version.version != res.version) {
						localStorage.setItem('v8version', JSON.stringify(res))
						window.location.reload();
					}
				}
			}
		});

		return true;
	}


}
